<template>
  <yams-template>
    <template #header>
      <div class="mr-5">
        <h4 class="text-primary">Accueil</h4>
      </div>
    </template>
    <template #content>
      <div class="d-flex row justify-content-start">
        <div class="col-md-3">
          <rows-counter premier_titre="Parc auto" second_titre="Vehicules" icon="/yams-rowcounter/vehicules.png"
            description="Tous les vehicules enregistrés à votre compte" linkName="vehicules"
            url="/api/vehicules?req_count=1">
          </rows-counter>
        </div>
        <div class="col-md-3">
          <rows-counter premier_titre="Operations" second_titre="Courses" icon="/yams-rowcounter/courses.png"
            linkName="courses" description="Courses réalisées " url="/api/courses?req_count=1">
          </rows-counter>
        </div>
        <div class="col-md-3">
          <rows-counter premier_titre="Operations" second_titre="Réservations" icon="/yams-rowcounter/reservation.png"
            linkName="demandes" description="Toutes les demandes de course en attente "
            url="/api/demandes?statut=En attente&req_count=1">
          </rows-counter>
        </div>
        <div class="col-md-4 col-lg-3">
          <rows-counter premier_titre="Clients" second_titre="Clients" icon="/yams-rowcounter/client.png"
            linkName="clients" description="Clients repertoriés" url="/api/utilisateurs?type=client&req_count=1">
          </rows-counter>
        </div>
        <div class="col-md-4 col-lg-3">
          <rows-counter premier_titre="Transporteurs" second_titre="Entreprises" icon="/yams-rowcounter/entreprises.png"
            linkName="transporteurs" description="Entreprises de transport"
            url="/api/utilisateurs?sous_type=entreprise&req_count=1">
          </rows-counter>
        </div>
        <div class="col-md-4 col-lg-3">
          <rows-counter premier_titre="Transporteurs" second_titre="Camionneurs" icon="/yams-rowcounter/camionneurs.png"
            linkName="transporteurs" description="Proprietaires de vehicule"
            url="/api/utilisateurs?sous_type=camionneur&req_count=1">
          </rows-counter>
        </div>
        <div class="col-md-4 col-lg-3">
          <rows-counter premier_titre="Transporteurs" second_titre="Coursiers" icon="/yams-rowcounter/coursiers.png"
            linkName="transporteurs" description="Les coursiers enregistrés"
            url="/api/utilisateurs?sous_type=coursier&req_count=1">
          </rows-counter>
        </div>
        <div class="col-md-4 col-lg-3">
          <rows-counter premier_titre="transporteurs" second_titre="Comptes" icon="/yams-rowcounter/comptes.png"
            linkName="transporteurs" description="Tout les utilisateurs enregistrés"
            url="/api/utilisateurs?req_count=1">
          </rows-counter>
        </div>
        <div class="col-md-4 col-lg-3">
          <rows-counter premier_titre="Utilisateurs" second_titre="Utilisateurs connectés"
            icon="/yams-rowcounter/user-connected.svg" linkName="active-users"
            description="Utilisateurs actuellement en ligne" url="/api/utilisateurs/connected?req_count=1">
          </rows-counter>
        </div>
      </div>
    </template>
  </yams-template>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import RowsCounter from '@/components/RowsCounter.vue';

export default defineComponent({
  name: 'HomeView',
  components: { RowsCounter },
})
</script>